import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mb-4 flex items-center justify-between rounded-lg border border-amber-200 bg-amber-50 px-4 py-2"
};
const _hoisted_2 = {
  class: "text-sm text-amber-700"
};
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center py-8"
};
const _hoisted_4 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_5 = {
  key: 0,
  class: "mt-4 flex items-center gap-3"
};
const _hoisted_6 = {
  key: 1,
  class: "flex gap-6"
};
const _hoisted_7 = {
  class: "flex-1 min-w-0"
};
const _hoisted_8 = {
  class: "mb-3 flex items-center justify-between"
};
const _hoisted_9 = {
  class: "text-xs text-slate-400"
};
const _hoisted_10 = {
  key: 0,
  class: "flex items-center gap-3"
};
const _hoisted_11 = {
  key: 1,
  class: "prose prose-sm max-w-none text-slate-700"
};
const _hoisted_12 = {
  key: 0,
  class: "w-48 shrink-0"
};
const _hoisted_13 = {
  class: "space-y-1"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "flex items-center justify-between"
};
const _hoisted_16 = {
  class: "font-medium"
};
const _hoisted_17 = {
  class: "flex items-center gap-1"
};
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_19 = {
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_20 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_21 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_22 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_23 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_24 = ["disabled"];
const _hoisted_25 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_26 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_27 = {
  key: 0,
  class: "mt-2 text-xs text-slate-400"
};
const _hoisted_28 = {
  key: 1,
  class: "mt-2 text-xs text-slate-400"
};
const _hoisted_29 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end shrink-0"
};
import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { meetingApi } from '@/api/meeting';
import { formatDateTime } from '@/utils/dateFormat';
import AppModal from '@/components/AppModal.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import FileUpload from '@/components/FileUpload.vue';
import FileAttachment from '@/components/FileAttachment.vue';
export default {
  __name: 'MinutesPanel',
  props: {
    meetingId: {
      type: [Number, String],
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 待召开 + 当前用户为会议组织者/主持人（由详情抽屉按归属计算传入）；纪要写操作仅管理者
    canManage: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    // 纪要保存后通知父组件（详情抽屉需刷新 latestMinutesVersion 等聚合数据）
    const emit = __emit;
    const loading = ref(false);
    // 最新纪要（后端无纪要时 latest 返回 null）
    const latest = ref(null);
    // 版本历史列表
    const versions = ref([]);

    // 正在查看的历史版本号（null 表示查看最新）
    const viewingVersion = ref(null);
    // 查看历史版本时缓存其完整详情（FILE 版本需要 minutesType/fileName，content 为 null）
    const historyDetail = ref(null);

    // 编辑弹窗
    const showEditModal = ref(false);
    const editContent = ref('');
    const saving = ref(false);

    // 上传纪要文件弹窗
    const showUploadModal = ref(false);
    // FileUpload 完成项暂存于此，watch 到新增后调用 uploadMinutesFile 发布为 FILE 版本
    const pendingUploads = ref([]);
    const uploading = ref(false);
    // 纪要文件绑定发布中（防重复提示）
    const publishing = ref(false);

    // 当前查看的版本详情：查看历史版本时为历史详情，否则为最新纪要
    const currentDetail = computed(() => {
      if (viewingVersion.value !== null) return historyDetail.value;
      return latest.value;
    });

    // 当前展示内容：FILE 版本 content 为 null，仅 TEXT 版本渲染富文本
    const currentContent = computed(() => currentDetail.value?.content || '');

    // 当前查看版本是否为 FILE 类型
    const currentIsFile = computed(() => currentDetail.value?.minutesType === 'FILE');

    // FILE 版本 → FileAttachment 单文件项（previewMode 'blob' 使预览/下载走 loader 按需换预签名 URL）
    const currentFileItem = computed(() => {
      const detail = currentDetail.value;
      if (!detail || detail.minutesType !== 'FILE' || !detail.fileName) return [];
      return [{
        id: detail.version,
        fileKey: detail.fileName,
        name: detail.fileName,
        size: detail.fileSize,
        contentType: detail.contentType,
        previewMode: 'blob'
      }];
    });

    // 预览/下载时按需换取 FILE 版本纪要文件的预签名访问 URL
    const loadMinutesFile = async file => {
      return meetingApi.getMinutesFileAccessUrl(props.meetingId, file.id);
    };
    const currentEditorId = computed(() => {
      if (viewingVersion.value !== null) {
        return versions.value.find(v => v.version === viewingVersion.value)?.editorId;
      }
      return latest.value?.editorId;
    });
    const currentCreateTime = computed(() => {
      if (viewingVersion.value !== null) {
        return versions.value.find(v => v.version === viewingVersion.value)?.createTime;
      }
      return latest.value?.createTime;
    });

    // 版本列表中高亮的版本号（查看历史时为历史版本号，否则为最新版本号）
    const activeVersion = computed(() => {
      if (viewingVersion.value !== null) return viewingVersion.value;
      return latest.value?.version ?? null;
    });

    // 拉取最新纪要（注意判空：无纪要时后端返回 null）
    const fetchLatest = async () => {
      if (!props.meetingId) return;
      loading.value = true;
      try {
        latest.value = (await meetingApi.getLatestMinutes(props.meetingId)) || null;
      } catch (error) {
        ElMessage.error('获取会议纪要失败');
        console.error('获取会议纪要失败:', error);
      } finally {
        loading.value = false;
      }
    };

    // 拉取版本历史
    const fetchVersions = async () => {
      if (!props.meetingId) return;
      try {
        versions.value = (await meetingApi.getMinutesVersionList(props.meetingId)) || [];
      } catch (error) {
        ElMessage.error('获取纪要版本失败');
        console.error('获取纪要版本失败:', error);
      }
    };

    // meetingId 变化时同时拉取最新纪要与版本列表，并复位查看状态
    watch(() => props.meetingId, () => {
      viewingVersion.value = null;
      historyDetail.value = null;
      fetchLatest();
      fetchVersions();
    }, {
      immediate: true
    });

    // 点击查看指定版本（只读）
    const handleViewVersion = async version => {
      if (latest.value && version === latest.value.version) {
        backToLatest();
        return;
      }
      try {
        const detail = await meetingApi.getMinutesVersion(props.meetingId, version);
        historyDetail.value = detail || null;
        viewingVersion.value = version;
      } catch (error) {
        ElMessage.error('获取历史版本失败');
        console.error('获取历史版本失败:', error);
      }
    };

    // 回到最新版本
    const backToLatest = () => {
      viewingVersion.value = null;
      historyDetail.value = null;
    };

    // 打开编辑弹窗：初始值为最新版本 content
    const openEdit = () => {
      editContent.value = latest.value?.content || '';
      showEditModal.value = true;
    };

    // 保存纪要（新增版本）
    const handleSave = async () => {
      if (!editContent.value || !editContent.value.trim()) {
        ElMessage.warning('请输入纪要内容');
        return;
      }
      saving.value = true;
      try {
        await meetingApi.saveMinutes(props.meetingId, {
          content: editContent.value
        });
        ElMessage.success('纪要已保存');
        showEditModal.value = false;
        viewingVersion.value = null;
        historyDetail.value = null;
        fetchLatest();
        fetchVersions();
        emit('changed');
      } catch (error) {
        ElMessage.error('保存纪要失败');
        console.error('保存纪要失败:', error);
      } finally {
        saving.value = false;
      }
    };

    // FileUpload 上传完成后发布为 FILE 类型纪要新版本（成功后后端自动通知全体参会人）
    watch(pendingUploads, async (newList, oldList) => {
      const prevLength = oldList?.length || 0;
      if (!newList || newList.length <= prevLength) return;
      const file = newList[newList.length - 1];
      publishing.value = true;
      try {
        await meetingApi.uploadMinutesFile(props.meetingId, {
          fileName: file.originalName || file.name,
          ossKey: file.fileKey,
          url: file.url,
          fileSize: file.fileSize || file.size,
          contentType: file.contentType
        });
        ElMessage.success('纪要文件已发布，已通知全体参会人');
        showUploadModal.value = false;
        viewingVersion.value = null;
        historyDetail.value = null;
        fetchLatest();
        fetchVersions();
        emit('changed');
      } catch (error) {
        ElMessage.error('纪要文件发布失败');
        console.error('纪要文件发布失败:', error);
      } finally {
        publishing.value = false;
        pendingUploads.value = [];
      }
    });
    __expose({
      fetchLatest,
      fetchVersions
    });
    return (_ctx, _cache) => {
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createElementBlock("div", null, [viewingVersion.value !== null ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, "正在查看历史版本 v" + _toDisplayString(viewingVersion.value), 1), _createElementVNode("button", {
        type: "button",
        class: "text-sm text-primary-600 hover:text-primary-700 cursor-pointer",
        onClick: backToLatest
      }, " 回到最新 ")])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
        class: "w-8 h-8 animate-spin text-primary-500",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [!latest.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无会议纪要", -1)), !__props.readonly && __props.canManage ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        onClick: openEdit
      }, " 编写纪要 "), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: _cache[0] || (_cache[0] = $event => showUploadModal.value = true)
      }, " 上传纪要文件 ")])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, " 编辑人 ID：" + _toDisplayString(currentEditorId.value || '-') + " · " + _toDisplayString(_unref(formatDateTime)(currentCreateTime.value) || '-'), 1), !__props.readonly && __props.canManage ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: _cache[1] || (_cache[1] = $event => showUploadModal.value = true)
      }, " 上传纪要文件 "), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: openEdit
      }, " 编辑纪要 ")])) : _createCommentVNode("", true)]), currentIsFile.value ? (_openBlock(), _createBlock(FileAttachment, {
        key: 0,
        files: currentFileItem.value,
        loader: loadMinutesFile
      }, null, 8, ["files"])) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, null, 512)), [[_directive_safe_html, currentContent.value]])]), versions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[13] || (_cache[13] = _createElementVNode("h4", {
        class: "mb-2 text-sm font-medium text-slate-700"
      }, "版本历史", -1)), _createElementVNode("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versions.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.version
        }, [_createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["w-full rounded-lg px-3 py-2 text-left text-sm transition-colors cursor-pointer", activeVersion.value === item.version ? 'bg-primary-50 text-primary-700' : 'text-slate-600 hover:bg-slate-50']),
          onClick: $event => handleViewVersion(item.version)
        }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, "v" + _toDisplayString(item.version), 1), _createElementVNode("span", _hoisted_17, [_createElementVNode("span", {
          class: _normalizeClass(["status-badge", item.minutesType === 'FILE' ? 'is-teal' : 'is-neutral'])
        }, _toDisplayString(item.minutesTypeDesc), 3), latest.value && item.version === latest.value.version ? (_openBlock(), _createElementBlock("span", _hoisted_18, "最新")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_19, " ID:" + _toDisplayString(item.editorId) + " · " + _toDisplayString(_unref(formatDateTime)(item.createTime) || '-'), 1)], 10, _hoisted_14)]);
      }), 128))])])) : _createCommentVNode("", true)]))], 64)), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showEditModal.value,
          size: "2xl",
          onClose: _cache[5] || (_cache[5] = $event => showEditModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("h3", _hoisted_21, _toDisplayString(latest.value ? '编辑纪要' : '编写纪要'), 1), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[2] || (_cache[2] = $event => showEditModal.value = false)
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_22, [_createVNode(RichTextEditor, {
            modelValue: editContent.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => editContent.value = $event),
            "upload-module": "meeting-minutes",
            "min-height": "300px",
            placeholder: "请输入会议纪要..."
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[4] || (_cache[4] = $event => showEditModal.value = false)
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: saving.value,
            onClick: handleSave
          }, _toDisplayString(saving.value ? '保存中...' : '保存'), 9, _hoisted_24)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showUploadModal.value,
          size: "sm",
          onClose: _cache[10] || (_cache[10] = $event => showUploadModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_cache[16] || (_cache[16] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "上传纪要文件", -1)), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[6] || (_cache[6] = $event => showUploadModal.value = false)
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_26, [_createVNode(FileUpload, {
            files: pendingUploads.value,
            "onUpdate:files": _cache[7] || (_cache[7] = $event => pendingUploads.value = $event),
            module: "meeting-minutes",
            bucket: "private",
            accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.md",
            "max-count": 1,
            "max-size": 100,
            onUploadingChange: _cache[8] || (_cache[8] = $event => uploading.value = $event)
          }, null, 8, ["files"]), uploading.value ? (_openBlock(), _createElementBlock("p", _hoisted_27, "文件上传中，上传完成后将自动发布为纪要新版本")) : _createCommentVNode("", true), publishing.value ? (_openBlock(), _createElementBlock("p", _hoisted_28, "纪要文件发布中...")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[9] || (_cache[9] = $event => showUploadModal.value = false)
          }, " 取消 ")])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]))]);
    };
  }
};